import React, { useState, useEffect } from 'react'
import classNames from 'classnames'

import { Image, Spinner } from 'components'
import { strings, t, adjust } from 'tools'
import config from 'config'

import TabeeAd      from './TabeeAd'
import LiteMailForm from './LiteForms/LiteMailForm'
import LiteDataForm from './LiteForms/LiteDataForm'
import LoginForm    from './LoginForm/LoginForm'
import ValidateForm from './LiteForms/ValidateForm'

const LiteForm = ({ id, data, search, company, email, socials, loading, canUpload, isDigital, isMine, onAvatar, clearErrors, getCompany, searchCard, onCreate, onMigrate }) => {
    const
        [ form, $form ] = useState({ email }),
        [ working, $working ] = useState(false),
        [ submit, $submit ] = useState(false),
        [ send, $sent ] = useState(false),
        [ error, $error ] = useState({}),
        [ migration, $migration ] = useState(false),
        [ scrolled, $scrolled ] = useState(false),

        name = `${data?.first_name} ${data?.last_name}`,

        check = {
            empty: val => !!val,
            email: ( email, ignoreCompany ) => (
                ignoreCompany
                    ? strings.validateEmail( email?.trim() )
                    : strings.validateEmail( email?.trim() ) && ( !company || !company.is_invalid )
            ),
            phone: phone => true, // /^\+[0-9]{5,12}$/.test( phone?.trim() ),
            submit: () => 
                {
                    const
                        res = {
                            email: !check.email( form.email ),
                            personal: !(!form.personal_email || check.email( form.personal_email, true )),
                            phone: !(!form.phone || check.phone( form.phone )),
                            first_name: !check.empty( form.first_name ),
                            last_name: !check.empty( form.last_name ),
                            company: company?.is_public ? false : ( !check.empty( form.company ) && ( !company || !company.is_invalid ) ),
                        }

                    if ( Object.values( res ).includes( true ) ) {
                        $working( false )
                        $error( res )
                        setTimeout(() => {
                            const
                                target = document.querySelector( '.has-error' )
                                
                            ;( target ) && ( target.scrollIntoView({ behavior: 'smooth', block: 'center' }) )
                        },100)
                        return false
                    }

                    return true
                }
        },

        update = ( key, value ) =>
            {
                $form({
                    ...form,
                    [key]: value
                })
            },
        
        fetchCompany = mail =>
            {
                getCompany( ( ( mail || form.email?.trim() ).split( '@' )[1] || '').trim() )
            },

        fetchSearch = e =>
            {
                ;( e ) && ( e.preventDefault() )
                $error({})

                if ( check.email( form.email, true ) ) {
                    $working( true )
                    searchCard( form.email )
                } else {
                    $error({ email: true })
                }
            },

        getHeight = () =>
            {
                if ( data ) return ''
                if ( ( !search || search?.length < 1 ) && ( !company || company.is_invalid ) ) {
                    return isDigital ? 300 : ''
                }
                return 755
            },

        getBranded = () =>
            {
                const
                    res = { height: getHeight() }

                if ( !company ) return res

                return {
                    ...res,
                    backgroundColor: company?.company_bg_color,
                    color: company && company.company_bg_color === company.company_text_color ? '#111' : company?.company_text_color,
                    border: [ '#000', '#000000', 'black', 'rgb(0,0,0)'].includes( company?.company_bg_color?.toLowerCase() )
                        ? `1px solid ${company?.company_bg_color !== company?.company_custom_text_color ? company?.company_custom_text_color : '#111111'}66`
                        : (
                            company && company.company_bg_color === company.company_text_color 
                                ? '1px solid #111' 
                                : `1px solid ${company?.company_text_color}`
                        )
                }
            },

        createCard = () =>
            {
                $error({})
                $submit(true)
                $working(true)
                clearErrors()
                
                if ( form.email ) {
                    fetchSearch()
                    fetchCompany( form.email )
                } else {
                    check.submit()
                }
            },
        migrationSpinner = () => <Spinner className="big-center" color={company && company.company_bg_color !== company.company_custom_text_color ? company.company_custom_text_color : '#111'} />,
        migrateCard = () =>
            {
                if ( !migration ) {
                    const
                        card = search.filter(card => !card.is_deleted && !card.is_archive && !card.parent && !card.migrated_to)[0]

                    onMigrate({ 
                        id, 
                        card_id: card.id,
                        user_id: card.owner_user.id
                    })

                    $migration( true )
                }

                return migrationSpinner()
            },

        onLinkedin = res =>
            {
                adjust.track( 'activation_social', { type: 'linkedin' } )
                $form({
                    ...form,
                    first_name: res.localizedFirstName,
                    last_name: res.localizedLastName,
                    personal_email: res.elements?.[0]?.['handle~']?.emailAddress,
                })
            },

        onVK = res =>
            {
                adjust.track( 'activation_social', { type: 'vk' } )
                localStorage.setItem( 'tabee-social-contact', res.session?.user?.href )
                $form({
                    ...form,
                    first_name: res.session.user?.first_name,
                    last_name: res.session.user?.last_name,
                    personal_email: res.session.user?.email,
                })
            },

        onFacebook = res =>
            {
                adjust.track( 'activation_social', { type: 'facebook' } )
                $form({
                    ...form,
                    first_name: res.first_name,
                    last_name: res.last_name,
                    personal_email: res.email,
                })
            },
        
        onGoogle = res =>
            {
                adjust.track( 'activation_social', { type: 'google' } )
                console.log( 'g', res )
                $form({
                    ...form,
                    first_name: res.profileObj?.givenName || res.profileObj?.name?.split(' ')[0],
                    last_name: res.profileObj?.familyName || res.profileObj?.name?.split(' ')[1],
                    personal_email: res.profileObj?.email,
                })
            },
            
        onApple = res =>
            {
                adjust.track( 'activation_social', { type: 'apple' } )
                $form({
                    ...form,
                    first_name: res.user?.name?.firstName,
                    last_name: res.user?.name?.lastName,
                    personal_email: res.user?.email
                })
            }

    useEffect(() => {
        if ( !search || submit ) return
        adjust.track( 'activation_started' )
        fetchCompany()
        //eslint-disable-next-line
    },[search])

    useEffect(() => {
        if ( !company || submit ) return

        if ( company.is_invalid ) {
            $error({ ...error, email: true })
        } else {
            $form({
                ...form,
                company: form.company || company.name
            })
        }
        
        $error({ ...error, company: false })
        $working( false )
        //eslint-disable-next-line
    },[company])

    useEffect(() => {
        if ( send || !working || !submit || !company || !search ) return
        
        if ( check.submit() ) {
            adjust.track( 'activation_completed' )
            $sent( true )
            onCreate({
                "id": id,
                "email": form.email?.toLowerCase(),
                "personal": form.personal_email?.toLowerCase(),
                "phone": form.phone,
                "language": "en",
                "first_name": form.first_name,
                "last_name": form.last_name,
                "position": form.position,
                "company": form.company,
                "company_domain": form.email.toLowerCase().split('@').pop(),
                "username": form.email.replace( /[^0-9a-zA-Z]+/g, '' ).toLowerCase(),
                "device": [
                    {
                        "platform": "3",
                        "token": "0",
                        "appv": "iNqxF-1L"
                    }
                ]
            })
        } else {
            $submit( false )
            $working( false )
        }
        //eslint-disable-next-line
    },[company, search])

    useEffect(() => {
        if ( data ) {
            $working( false )
            $submit( false )
        }
    },[data])

    useEffect(() => {
        if ( data && !scrolled ) {
            setTimeout(() => document.getElementById( 'scroll-here' )?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300)
            $scrolled( true )
        }
        //eslint-disable-next-line
    },[data])

    return (
        <>
            <main className="public-card-lite-form-wrapper mobile-hidden">
                <section className="public-card-hello mobile-only">
                    <div className="public-card-phrase">
                        <h1>{t('publicCard.UNSUPPORTED_DEVICE')}</h1>
                        <br/>
                        <p>{t('publicCard.UNSUPPORTED_DEVICE_DESC')}</p>
                    </div>
                </section>
                <TabeeAd
                    data    = { data }
                    id      = { data?.id }
                    company = { company }
                    isLite  = { data?.is_lite || !!company || search?.length > 0 }
                    isMine  = { isMine }
                />
            </main>
            <main className="public-card-lite-form-wrapper desktop-hidden">
                {
                    ( !data && !isDigital ) && (
                        <section className="public-card-hello mobile-only">
                            <div className="public-card-phrase">
                                <h1>{t('publicCard.ACTIVATE_TABEE')}</h1>
                                <p style={{ textAlign: 'left' }}>{t('publicCard.ACTIVATE_TABEE_DESC')}</p>
                            </div>
                        </section>
                    )
                }
                <section className="public-card-hello">
                    {
                        data && (
                            <div className={classNames("public-card-avatar", ( canUpload && !data.owner_user?.avatar ) && 'with-upload', !!data.owner_user?.avatar && 'with-image' )}>
                                <div className="public-card-avatar" onClick={loading ? null : () => onAvatar()}>
                                    {
                                        loading
                                            ? <Spinner />
                                            : (
                                                <Image 
                                                    resize    = { !!data.owner_user?.avatar }
                                                    fallback  = { 
                                                        canUpload
                                                            ? `data:image/svg+xml;charset=utf-8;base64,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`
                                                            : `https://server.tabee.mobi/static/tabee/images/mails/user-image.png`
                                                    } 
                                                    src       = { data.owner_user.avatar }
                                                    alt       = { name }
                                                    width     = "80"
                                                    height    = "80"
                                                />
                                            )
                                    }
                                </div>
                            </div>
                        )
                    }
                    {
                        data && (
                            <div className="public-card-phrase">
                                <h1 id="scroll-here">{t('publicCard.VALIDATE_EMAIL')}</h1>
                                <p style={{ textAlign: 'left' }}>{t('publicCard.VALIDATE_EMAIL_DESC')}</p>
                            </div>
                        )
                    }
                </section>
                <div 
                    className = {classNames(
                        'public-card-lite-form', 
                        'public-card-form', 
                        [ '#fff', '#ffffff', 'rgb(255,255,255)' ].includes( getBranded().backgroundColor?.toLowerCase()?.replace( / +/g, '' ) ) && 'is-light-bg'
                    )}
                    style = { getBranded() }
                >
                    <h2>
                        { 
                            !company?.company_logo_for_passbook && ( 
                                <span>{t('publicCard.COMPLETED_IDENTITY')}</span>
                            )
                        }
                        {
                            ( company?.company_logo_for_passbook ) && (
                                <img 
                                    src       = { `${config.api.url}/media/${company.company_logo_for_passbook}` }
                                    alt       = { company.name }
                                    width     = "100"
                                    height    = "32"
                                />
                            )
                        }
                    </h2>
                    {
                        data
                            ? (
                                <ValidateForm
                                    data    = { data }
                                    name    = { name }
                                    company = { company }
                                />
                            )
                            : (
                                (( !search || search?.length < 1 ) && ( !company || company.is_invalid ) )
                                    ? (   
                                        <LiteMailForm
                                            form      = { form }
                                            error     = { error }
                                            working   = { working }
                                            isDigital = { isDigital }

                                            onUpdate    = { update }
                                            fetchSearch = { fetchSearch }
                                        />
                                    )
                                    : (
                                        search && search?.length > 0
                                            ? (
                                                ( search.filter(card => !card.is_deleted && !card.is_archive && !card.parent && !card.migrated_to).length > 0 )
                                                    ? (
                                                        migration
                                                            ? migrationSpinner()
                                                            : migrateCard()
                                                    )
                                                    : (
                                                        <LoginForm
                                                            email = { form.email }
                                                            buttonStyle = {{
                                                                color: company?.company_bg_color,
                                                                backgroundColor: (
                                                                    !company?.company_bg_color
                                                                        ? ''
                                                                        : company && company.company_bg_color !== company.company_custom_text_color ? company.company_custom_text_color : '#111'
                                                                ),
                                                                border: `2px solid ${company?.company_bg_color}`
                                                            }}
                                                        />
                                                    )
                                            )
                                            : (
                                                <LiteDataForm
                                                    form    = { form }
                                                    error   = { error }
                                                    working = { working }
                                                    socials = { socials }
                                                    buttonStyle = {{
                                                        color: company?.company_bg_color,
                                                        backgroundColor: (
                                                            !company?.company_bg_color
                                                                ? ''
                                                                : company && company.company_bg_color !== company.company_custom_text_color ? company.company_custom_text_color : '#111'
                                                        ),
                                                        border: `2px solid ${company?.company_bg_color}`
                                                    }}

                                                    onUpdate   = { update }
                                                    onDone     = { createCard } 
                                                    onGoogle   = { onGoogle }
                                                    onFacebook = { onFacebook }
                                                    onLinkedin = { onLinkedin }
                                                    onApple    = { onApple }
                                                    onVK       = { onVK }
                                                />
                                            )
                                    )
                            )
                    }
                </div>
            </main>
        </>
    )
} 

export default LiteForm